/**
 * Tenant configuration initialization.
 */

import { tenantConfig } from '../services/tenantConfigService'
import { config } from '../services/configService'
import { log } from '../utils/DebugLogger'

interface CriticalTenantError extends Error {
  isCritical?: boolean
  statusCode?: number
}

const showCriticalError = (_error: Error): void => {
  const errorDiv = document.createElement('div')
  errorDiv.innerHTML = `
    <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
                background: #f8d7da; color: #721c24; padding: 30px; border-radius: 8px;
                box-shadow: 0 4px 6px rgba(0,0,0,0.1); z-index: 10000; max-width: 500px; text-align: center;">
      <h2 style="margin: 0 0 15px 0; font-size: 24px;">⚠️ Erro de Configuração</h2>
      <p style="margin: 0 0 10px 0; font-size: 16px;">
        <strong>Não foi possível carregar a configuração do sistema.</strong>
      </p>
      <p style="margin: 0 0 20px 0; font-size: 14px; color: #555;">
        Tente recarregar a página. Se continuar, entre em contato com o administrador do sistema.
      </p>
      <button onclick="window.location.reload()"
              style="background: #721c24; color: white; border: none; padding: 10px 20px;
                     border-radius: 5px; cursor: pointer; font-size: 14px;">
        Recarregar Página
      </button>
    </div>
  `
  document.body.appendChild(errorDiv)
}

export async function initTenant(): Promise<void> {
  log('App', 'bootstrap', '🏢 Loading tenant configuration...')

  try {
    await tenantConfig.loadConfig()
    config.setDisabledFeatures(tenantConfig.getDisabledFeatures())
    log('App', 'bootstrap', '✅ Tenant config loaded:', tenantConfig.getTenantInfo())

    document.documentElement.offsetHeight
    log('App', 'bootstrap', '✅ CSS variables applied to DOM (forced reflow)')
  } catch (tenantError) {
    const err = tenantError as CriticalTenantError

    if (err.isCritical) {
      log('App', 'bootstrap', '❌ Critical tenant config error - stopping app mount', err)
      showCriticalError(err)
      throw err
    }

    log('App', 'bootstrap', '⚠️ Tenant config failed, using defaults', err)
  }
}

export { tenantConfig }
